(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGOVue"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGOVue", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/self-selected-stocks/render"] = factory(require("FEGOVue"), require("FEGORender"));
	else
		root["/fego/component/self-selected-stocks/render"] = factory(root["FEGOVue"], root["FEGORender"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__9666__, __WEBPACK_EXTERNAL_MODULE__5322__) {
return 